import "./ConfigurationGroupRecordingEdit.html";
import "./ConfigurationGroupRecordingEdit.scss";

import "../../../../Forms/HolidaySchedule/HolidayScheduleComponent";
import "../../../../Forms/ScheduleExceptions/ScheduleExceptionsComponent";
import "../../../../Forms/TemporaryWeeklySchedule/TemporaryWeeklyScheduleComponent";
import "../../../../Forms/WeeklySchedule/WeeklyScheduleComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ConfigurationGroupRecordingEditComponentController from "./ConfigurationGroupRecordingEditComponentController";

export default class ConfigurationGroupRecordingEditComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ConfigurationGroupRecordingEditComponentController;
        this.templateUrl =
            "/App/Components/Site/ConfigurationGroups/Recording/Edit/ConfigurationGroupRecordingEdit.html";
    }
}

module("mmManagePortal").component("mmConfigurationGroupRecordingEdit", new ConfigurationGroupRecordingEditComponent());
